<template>
  <div
    class="modal fade"
    id="sms-notifications"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="notifications-sms-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">{{ $t("notifications.type.sms") }}</h4>
          </div>
          <div class="row border gap-y-4 p-4">
            <div class="col-md-4">
              <label class="form-label">{{
                $t("notifications.config.sms_username")
              }}</label>
              <input
                type="text"
                class="form-control"
                autocomplete="one-time-code"
                v-model="notifications.sms_username"
              />
            </div>
            <div class="col-md-4">
              <label class="form-label">{{
                $t("notifications.config.sms_password")
              }}</label>
              <input
                type="password"
                class="form-control"
                autocomplete="one-time-code"
                v-model="notifications.sms_password"
              />
            </div>
            <div class="col-md-4">
              <label class="form-label">{{
                $t("notifications.config.sms_sender")
              }}</label>
              <input
                type="text"
                class="form-control"
                autocomplete="one-time-code"
                v-model="notifications.sms_from"
              />
            </div>
          </div>
          <div
            class="row border gap-y-4 p-4"
            v-if="hasPrivilege('settings_sms_messages')"
          >
            <div
              class="row"
              v-if="
                notifications.sms_expiration_message_enabled ||
                  notifications.sms_expiring_soon_message_enabled ||
                  notifications.sms_renew_message_enabled ||
                  notifications.sms_sham_renew_message_enabled
              "
            >
              <div class="col-12">
                <h5>{{ $t("notifications.config.available_variables") }}</h5>
                <p class="text-muted">
                  {{ $t("notifications.config.variables_note") }}
                </p>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.username")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{username}"
                    type="text"
                    class="form-control"
                    disabled
                    id="username-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('username-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.fullname")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{full_name}"
                    type="text"
                    class="form-control"
                    disabled
                    id="fullname-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('fullname-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.profile_name")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{profile}"
                    type="text"
                    class="form-control"
                    disabled
                    id="profile-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('profile-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.profile_price")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{price}"
                    type="text"
                    class="form-control"
                    disabled
                    id="price-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('price-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.paid_amount")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{paid_amount}"
                    type="text"
                    class="form-control"
                    disabled
                    id="paid-amount-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('paid-amount-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.debt")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{debt}"
                    type="text"
                    class="form-control"
                    disabled
                    id="debt-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('debt-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.discount")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{discount}"
                    type="text"
                    class="form-control"
                    disabled
                    id="discount-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('discount-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.total_debts")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{total_debt}"
                    type="text"
                    class="form-control"
                    disabled
                    id="total-debts-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('total-debts-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.invoice_number")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{invoice_number}"
                    type="text"
                    class="form-control"
                    disabled
                    id="invoice-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('invoice-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.sham_cash_code")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{shamcode}"
                    type="text"
                    class="form-control"
                    disabled
                    id="shamcode-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('shamcode-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.expires_at")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{expires_at}"
                    type="text"
                    class="form-control"
                    disabled
                    id="expires-at-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('expires-at-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.network_name")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{network_name}"
                    type="text"
                    class="form-control"
                    disabled
                    id="network-name-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('network-name-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div>
                {{
                  $t("notifications.config.do_not_put_links_inside_the_message")
                }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.sms_expiration_message_enabled"
                />
                {{ $t("notifications.config.expiration_message") }}
              </label>
              <textarea
                v-if="notifications.sms_expiration_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.sms_expiration_message"
                :class="{ 'is-invalid': errors.custom_expiration_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.sms_expiration_message_enabled"
                class="text-end text-muted"
                :class="{ 'invalid-feedback': errors.custom_expiration_length }"
              >
                201/{{ notifications.sms_expiration_message.length }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.sms_renew_message_enabled"
                />
                {{ $t("notifications.config.renew_message") }}
              </label>
              <textarea
                v-if="notifications.sms_renew_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.sms_renew_message"
                :class="{ 'is-invalid': errors.custom_renew_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.sms_renew_message_enabled"
                class="text-end text-muted"
                :class="{ 'invalid-feedback': errors.custom_renew_length }"
              >
                201/{{ notifications.sms_renew_message.length }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.sms_expiring_soon_message_enabled"
                />
                {{ $t("notifications.config.expiring_soon_message") }}
              </label>
              <textarea
                v-if="notifications.sms_expiring_soon_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.sms_expiring_soon_message"
                :class="{ 'is-invalid': errors.custom_expiring_soon_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.sms_expiring_soon_message_enabled"
                class="text-end text-muted"
                :class="{
                  'invalid-feedback': errors.custom_expiring_soon_length,
                }"
              >
                201/{{ notifications.sms_expiring_soon_message.length }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.sms_sham_renew_message_enabled"
                />
                {{ $t("notifications.config.sham_renew_message") }}
              </label>
              <textarea
                v-if="notifications.sms_sham_renew_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.sms_sham_renew_message"
                :class="{ 'is-invalid': errors.custom_sham_renew_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.sms_sham_renew_message_enabled"
                class="text-end text-muted"
                :class="{ 'invalid-feedback': errors.custom_sham_renew_length }"
              >
                201/{{ notifications.sms_sham_renew_message.length }}
              </div>
            </div>
          </div>
          <div class="row mt-6">
            <div class="col-12 text-center">
              <button
                class="btn btn-primary"
                @click.prevent="store"
                :disabled="!validated || loading"
              >
                {{ $t("control.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import QrcodeVue from "qrcode.vue";
import { hasPrivilege } from "../../global_constants";

export default {
  name: "notificationsSms",
  data() {
    return {
      qr: null,
      loading: false,
      status: "",
      notifications: {
        sms_username: "",
        sms_password: "",
        sms_from: "",
        sms_expiration_message: "",
        sms_expiration_message_enabled: false,
        sms_expiring_soon_message: "",
        sms_expiring_soon_message_enabled: false,
        sms_renew_message: "",
        sms_renew_message_enabled: false,
        sms_sham_renew_message: "",
        sms_sham_renew_message_enabled: false,
      },
      instance: {
        instance: "",
      },
      instance_error: null,
      validated: true,
      errors: {
        expired: null,
        expiring: null,
        custom_expiration_length: null,
        custom_expiring_soon_length: null,
        custom_renew_length: null,
        custom_sham_renew_length: null,
        renew: null,
      },
      inside_page: true,
      showDeleteWa: false,
      text_direction:
        this.$i18n.locale == "ar" ? "direction:rtl" : "direction:ltr",
    };
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },

  async created() {
    this.fetchSettings();
  },
  watch: {
    $route(to, from) {
      this.inside_page = false;
    },
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async getQr() {
      // this.loading = true;
      var res = await axios.get("wa/qr");
      if (res.status == 200) {
        this.qr = res.data.qr_code;
      }
      // this.loading = false;
    },
    async statusCheck() {
      var response = await axios.get("wa/status");
      if (response.status == 200) {
        if (response.data.status == "open") this.status = "session_connected";
        else this.status = "qr";
        if (this.status == "browser tab closed")
          this.status = "session_not_found";
      } else if (response.status == 210) {
        this.status = "no_instance";
      }

      //this.status = "no_instance";
    },
    async deleteWa() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "notifications.this_will_delete_whatsapp_key_and_disconnect_it",
        ),
        icon: "error",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            var response = await axios.post("wa/clear");

            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("notifications.whatsapp_key_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
            if (response.status == 200) {
              location.reload();
            }
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async fetchSettings() {
      this.loading = true;
      const response = await axios.get("sms/notifications");
      if (response.status == 200) {
        var temp = response.data.data;
        temp.forEach((element) => {
          switch (element.key) {
            case "sms_notifications_expiration_message":
              this.notifications.sms_expiration_message = element.value;
              if (element.value != null)
                this.notifications.sms_expiration_message_enabled = true;
              break;
            case "sms_notifications_renew_message":
              this.notifications.sms_renew_message = element.value;
              if (element.value != null)
                this.notifications.sms_renew_message_enabled = true;
              break;
            case "sms_notifications_expiring_soon_message":
              this.notifications.sms_expiring_soon_message = element.value;
              if (element.value != null)
                this.notifications.sms_expiring_soon_message_enabled = true;
              break;
            case "sms_notifications_sham_renew_message":
              this.notifications.sms_sham_renew_message = element.value;
              if (element.value != null)
                this.notifications.sms_sham_renew_message_enabled = true;
              break;
            default:
              break;
          }
        });
      }
      this.loading = false;
    },
    async store() {
      this.loading = true;
      const response = await axios.post("wa/notifications", this.notifications);
      if (response.status == 200) {
        this.$notify({
          text: this.$t("messages.sms_settings_updated_successfully"),
          type: "success",
        });
      }
      this.loading = false;
    },
    async instanceCheck() {
      this.loading = true;
      const response = await axios.post("wa/instance", this.instance);
      if (response.status == 200) {
        this.$swal({
          title: this.$t("notifications.wa.license_validated"),
          icon: "success",
        });
        location.reload();
      } else if (response.status == 210) {
        this.instance_error = this.$t(
          `errors.notifications.wa.license_not_valid`,
        );
      }
      this.loading = false;
    },
    async updateStatus() {
      this.statusCheck();
      if (this.status == "session_not_connected") this.getQr();
    },
    copyToClip(id) {
      // Get the text field
      var copyText = document.getElementById(id);

      // Select the text field
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);
      this.$notify({
        text: this.$t("control.copied_to_clipboard"),
        type: "info",
      });
    },
    validate() {
      this.validated = true;
      this.errors.expired = null;
      this.errors.expiring = null;
      this.errors.renew = null;
      this.errors.custom_expiration_length = null;
      this.errors.custom_expiring_soon_length = null;
      this.errors.custom_renew_length = null;
      this.errors.custom_sham_renew_length = null;
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      if (
        this.notifications.sms_expiration_message.includes(".") ||
        this.notifications.sms_expiration_message.includes("http")
      ) {
        this.errors.custom_expiration_length = this.$t(
          "errors.notifications.wa.url",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_expiring_soon_message.includes(".") ||
        this.notifications.sms_expiring_soon_message.includes("http")
      ) {
        this.errors.custom_expiring_soon_length = this.$t(
          "errors.notifications.wa.url",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_renew_message.includes(".") ||
        this.notifications.sms_renew_message.includes("http")
      ) {
        this.errors.custom_renew_length = this.$t(
          "errors.notifications.wa.url",
        );
        this.validated = false;
      }

      if (
        this.notifications.sms_expiration_message_enabled &&
        this.notifications.sms_expiration_message.length > 201
      ) {
        this.errors.custom_expiration_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_expiring_soon_message_enabled &&
        this.notifications.sms_expiring_soon_message.length > 201
      ) {
        this.errors.custom_expiring_soon_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_renew_message_enabled &&
        this.notifications.sms_renew_message.length > 201
      ) {
        this.errors.custom_renew_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_sham_renew_message_enabled &&
        this.notifications.sms_sham_renew_message.length > 201
      ) {
        this.errors.custom_sham_renew_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
    },
  },
  components: { QrcodeVue },
};
</script>
